(() => {
  const init = () => {
    document.querySelectorAll('[data-stock-bar]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const form = bar.closest('form');
      let variants;
      try { variants = JSON.parse(bar.querySelector('[data-stock-variants]').textContent); } catch { bar.hidden = true; return; }
      const update = () => {
        const id = form.querySelector('[name="id"]').value;
        const v = variants.find(item => String(item.id) === id);
        const threshold = Number(bar.dataset.threshold);
        const show = v && v.tracked && v.deny && v.available && v.price > 0 && v.quantity > 0 && v.quantity <= threshold;
        bar.hidden = !show;
        const status = form.querySelector('[data-stock-message]');
        if (status) status.hidden = Boolean(show);
        if (!show) return;
        const level = v.quantity === 1 ? 'last' : v.quantity === 2 ? 'pair' : 'few';
        bar.dataset.level = level;
        const message = level === 'last' ? bar.dataset.one : level === 'pair' ? bar.dataset.pair : bar.dataset.many;
        bar.querySelector('[data-stock-label]').textContent = message.replace('[count]', v.quantity);
        bar.querySelector('[data-stock-note]').textContent = level === 'last' ? bar.dataset.noteLast : level === 'pair' ? bar.dataset.notePair : bar.dataset.noteFew;
        bar.querySelector('[data-stock-fill]').style.width = `${Math.min(100, v.quantity / threshold * 100)}%`;
      };
      form.addEventListener('change', update);
      update();
    });
    const dialog = document.querySelector('[data-pin-zoom]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const stage = dialog.querySelector('[data-zoom-stage]');
    const image = dialog.querySelector('[data-zoom-image]');
    const level = dialog.querySelector('[data-zoom-level]');
    const minus = dialog.querySelector('[data-zoom-out]');
    const plus = dialog.querySelector('[data-zoom-in]');
    const links = [...document.querySelectorAll('.product-gallery a.product-photo')];
    let zoom = 1, selected = 0, opener, oldOverflow;
    const size = () => {
      if (!image.naturalWidth) return;
      const w = stage.clientWidth - 48, h = stage.clientHeight - 48;
      const base = Math.min(w / image.naturalWidth, h / image.naturalHeight, 1);
      image.style.width = `${image.naturalWidth * base * zoom}px`;
      image.style.height = `${image.naturalHeight * base * zoom}px`;
      stage.classList.toggle('is-zoomed', zoom > 1);
      level.value = `${Math.round(zoom * 100)}%`;
      minus.disabled = zoom <= 1; plus.disabled = zoom >= 3;
    };
    const show = index => {
      selected = (index + links.length) % links.length;
      zoom = 1;
      const link = links[selected];
      image.src = link.href;
      image.alt = link.querySelector('img')?.alt || document.querySelector('.product-details h1')?.textContent || '';
      dialog.querySelector('[data-zoom-caption]').textContent = image.alt;
      dialog.querySelector('[data-zoom-previous]').hidden = links.length < 2;
      dialog.querySelector('[data-zoom-next]').hidden = links.length < 2;
      stage.scrollTo(0, 0); size();
    };
    image.addEventListener('load', size);
    links.forEach((link, index) => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault(); opener = link; oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden'; dialog.showModal(); show(index);
      dialog.querySelector('[data-zoom-close]').focus();
    }));
    dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.body.style.overflow = oldOverflow || ''; opener?.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    plus.addEventListener('click', () => { zoom = Math.min(3, zoom + .5); size(); });
    minus.addEventListener('click', () => { zoom = Math.max(1, zoom - .5); size(); });
    image.addEventListener('dblclick', () => { zoom = zoom === 1 ? 2 : 1; size(); });
    dialog.querySelector('[data-zoom-previous]').addEventListener('click', () => show(selected - 1));
    dialog.querySelector('[data-zoom-next]').addEventListener('click', () => show(selected + 1));
    window.addEventListener('resize', () => { if (dialog.open) size(); });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

